<template>
  <div>
    <div class="imgs">
      <img class="vpcsmb-banner-img" src="../assets/img/wanfang.jpg" />
      <div class="btn_in" @click="toActiveVip">激活VIP</div>
      <div
        style="background: #fff; padding: 0.6rem 0.3rem; margin: 0 0.5rem"
        class="words"
      >
        <p>活动说明：</p>
        <p>
          您已获赠一个月万方检测VIP会员资格，点击以上按钮即可激活，激活以后在有效期内查重论文均可享受VIP折扣。
        </p>
        <p>
          如需帮助请联系客服：
          <a
            href="https://chatbot.weixin.qq.com/webapp/Ws75Px9atGV9s4UkR64nosl5FI8L7b?isFloat=false&robotName=%E4%B8%87%E6%96%B9%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D"
            style="color: #228ef7"
            >在线客服</a
          >
        </p>
        <p>本活动最终解释权归本公司所有。</p>
        <p style="height: 1rem"></p>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      wxdev: false,
    };
  },
  created() {
    const ua = window.navigator.userAgent.toLowerCase();
    this.wxdev = ua.match(/MicroMessenger/i) == "micromessenger";
    // if (window.sessionStorage.getItem("Token")) return;
    if (this.wxdev) {
      if (window.sessionStorage.getItem("Token")) return;
      this.$router.push({
        path: "/blankpage",
        query: {
          currentpath: "/active_vip",
        },
      });
    } else {
      this.$dialog
        .alert({
          message: "请在微信浏览器打开该页面",
        })
        .then(() => {
          this.$router.replace("/");
        });
    }
  },
  methods: {
    toActiveVip() {
      this.$http
        .activeVip()
        .then((res) => {
          Toast.success("激活成功");
        })
        .catch((err) => {
          Toast(err.response.data.message || err.response.data.msg);
        })
        .finally(() => {
          this.$router.replace("/");
        });
    },
  },
};
</script>

<style scoped>
.imgs {
  position: relative;
}
.vpcsmb-banner-img {
  width: 100%;
}

.btn_in {
  /* border: 0.16rem solid rgb(213, 41, 34); */
  background: rgb(255, 104, 4);

  color: #fff;
  font-weight: bold;
  text-align: center;
  padding: 0.33rem 0;
  border-radius: 6%;
  width: 3rem;
  position: absolute;
  bottom: 30%;
  left: 30%;
}
.words p {
  margin-bottom: 0.2rem;
  line-height: 1.7;
  text-indent: 1em;
}
.words {
  position: absolute;
  top: 90%;
}
</style>
